import {
    Component,
    OnInit,
    ElementRef,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { OddConstant } from '~/constant/odd.constant';
import { GetOddDataAll } from '~/modules/getOddData.all';
import { lg } from '~/modules/colorLog';
import { uiHelper } from '~/helpers/ui.helper';
import { translationHelper } from '~/helpers/translation.helper';

@Component({
    selector: 'expandView',
    templateUrl: './expand.view.html',
})
export class ExpandView implements OnChanges {
    @Input() fixtureItem;
    @Input() matchId;
    allOdds;
    allOddsStatic;

    @Input() isShow = false;
    @Input() typeOfList: string;

    expandListConstants = {};
    sportEnum = 1;

    constructor(
        public tournamentsService: TournamentsService,
        private _OD: OddConstant,
        public _GDAll: GetOddDataAll,
        private _uiHelper: uiHelper,
        private _translate: translationHelper,
    ) {
        this.sportEnum = this._uiHelper.sportEnum;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.isShow) {
            this.getExpandData();
        }
    }

    trackByFn(index, item) {
        if (!item) {
            return null;
        }
        return item.headerText;
    }

    getExpandData() {
        this.allOdds = this._GDAll.get(this.typeOfList, this.matchId);
        //console.log(this.allOdds);
        this.rebuildData();
    }

    rebuildData() {
        if (this.typeOfList === 'pre') {
            this.expandListConstants = this._OD.EXPAND_LIST_PRE;
        } else if (this.typeOfList === 'live') {
            this.expandListConstants = this._OD.EXPAND_LIST_LIVE;
        }

        const LIST = this.expandListConstants;
        const ALL_ODD = this.allOdds;
        const returnedDataAll = [];

        // IF odd data contains given odd type, filter return to odd array.
        Object.keys(LIST).forEach(LIST_KEY => {
            const ITEM_DATA = LIST[LIST_KEY];
            const LIST_KEY_PURE = LIST_KEY.slice(1);

            let ITEMS_ARRAY = (ALL_ODD || []).filter(item => {
                return item && item[0] && item[0].OddTypeId && item[0].OddTypeId.toString() === LIST_KEY_PURE;
            });

            if (!ITEMS_ARRAY || ITEMS_ARRAY.length === 0 || !ITEMS_ARRAY[0] || !ITEMS_ARRAY[0][0]) {
                return;
            }

            // If have onlySupportTypes keys, applied filter.
            if (
                LIST[LIST_KEY].onlySupportTypes &&
                !(LIST[LIST_KEY].onlySupportTypes.filter(x => x == this.sportEnum).length > 0)
            ) {
                return;
            }

            const returnedData = {
                headerText: ITEMS_ARRAY[0][0].GroupName || '',
                isSpecialValueShow: ITEMS_ARRAY[0][0].SpecialBetValue != '',
                textLocation: ITEM_DATA.textLocation,
                gridWidth: ITEM_DATA.gridWidth || 1,
                specialText: ITEM_DATA.specialText,
                col: ITEM_DATA.col,
                oddList: [],
                appendOddList: [],
            };

            ITEMS_ARRAY = this.items_array_mapper(ITEMS_ARRAY, ITEM_DATA);

            if (!ITEM_DATA.groupHandler || typeof ITEM_DATA.groupHandler !== 'function') {
                return;
            }

            ITEMS_ARRAY = ITEM_DATA.groupHandler(ITEMS_ARRAY, ITEM_DATA);

            // Append Odds
            if (LIST[LIST_KEY].appendOdds && Object.keys(ITEM_DATA.appendOdds || {}).length > 0) {
                const APPEND_LIST = ITEM_DATA.appendOdds;
                let appendOddArray: any = [];

                Object.keys(APPEND_LIST).forEach(APPEND_LIST_KEY => {
                    const APPEND_ITEM_DATA = APPEND_LIST[APPEND_LIST_KEY];
                    if (!APPEND_ITEM_DATA || !APPEND_ITEM_DATA.groupHandler) {
                        return;
                    }

                    let APPEND_ITEMS_ARRAY = (ALL_ODD || []).filter(item => {
                        return item && item[0] && item[0].OddTypeId && item[0].OddTypeId.toString() === APPEND_LIST_KEY;
                    });

                    APPEND_ITEMS_ARRAY = this.items_array_mapper(APPEND_ITEMS_ARRAY, APPEND_ITEM_DATA);
                    APPEND_ITEMS_ARRAY = APPEND_ITEM_DATA.groupHandler(APPEND_ITEMS_ARRAY, APPEND_ITEM_DATA, true);

                    let New_APPEND_ITEMS_ARRAY = APPEND_ITEMS_ARRAY.map(obj => {
                        if (!obj || !obj.rows || !obj.rows.length || !obj.rows[0] || !obj.rows[0].length) {
                            return {
                                ...obj,
                                isSecondHalf: false,
                            };
                        }

                        const oddTypeId = obj.rows[0][0] && obj.rows[0][0].OddTypeId;
                        return {
                            ...obj,
                            isSecondHalf: oddTypeId ? this.GetSecondHalfStatus(oddTypeId) : false,
                        };
                    });

                    appendOddArray.push(New_APPEND_ITEMS_ARRAY);
                });
                returnedData.appendOddList = appendOddArray.flat();
            }

            returnedData.oddList = ITEMS_ARRAY;
            returnedDataAll.push(returnedData);
        });

        this.allOdds = returnedDataAll;
    }

    GetSecondHalfStatus(OddTypeId) {
        // İkinci yarı olanlar Gösteriliyor ( 2.HT)
        if (
            OddTypeId == 1702 ||
            OddTypeId == 1615 ||
            OddTypeId == 1691 ||
            OddTypeId == 1699 ||
            OddTypeId == 1644 ||
            OddTypeId == 1778 ||
            OddTypeId == 1779 ||
            OddTypeId == 1785 ||
            OddTypeId == 194 ||
            OddTypeId == 191 ||
            OddTypeId == 711 ||
            OddTypeId == 193 ||
            OddTypeId == 192 ||
            OddTypeId == 190
        ) {
            return true;
        } else {
            return false;
        }
    }

    items_array_mapper(ITEMS_ARRAY, ITEM_DATA) {
        if (!ITEMS_ARRAY || !ITEMS_ARRAY.length) {
            return [];
        }

        if (ITEM_DATA.filterHandler) {
            ITEMS_ARRAY[0] = ITEM_DATA.filterHandler(ITEMS_ARRAY) || [];
        }

        return ITEMS_ARRAY.filter(item => item && Array.isArray(item)).map((item, index) => {
            return item
                .filter(item2 => item2)
                .map((item2, index2) => {
                    let whichTextDisplay = '';
                    if (ITEM_DATA.specialTextNotDivide) {
                        whichTextDisplay = (ITEM_DATA.specialText && ITEM_DATA.specialText[index2]) || '';
                    } else {
                        whichTextDisplay =
                            (ITEM_DATA.specialText && ITEM_DATA.specialText[index2 % ITEM_DATA.col]) || '';
                    }

                    if (ITEM_DATA.specialTextHandler && typeof ITEM_DATA.specialTextHandler === 'function') {
                        whichTextDisplay = ITEM_DATA.specialTextHandler(item2);
                    }

                    // Handle translation markers if present
                    if (whichTextDisplay && whichTextDisplay.startsWith('{') && whichTextDisplay.endsWith('}')) {
                        whichTextDisplay = this._translate.getT(whichTextDisplay.slice(1, -1));
                    }

                    return {
                        ...item2,
                        hasUpperText: ITEM_DATA.textLocation === 'inside',
                        isBelowNegativeDontShow: ITEM_DATA.isBelowNegativeDontShow,
                        upperText: whichTextDisplay,
                    };
                });
        });
    }
}
